export var RED = '#f44';
export var BLUE = '#1989fa';
export var GREEN = '#07c160';
export var WHITE = '#fff';
export var GRAY_DARK = '#969799';


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vant@1.6.17@vant/es/utils/color.js
// module id = null
// module chunks = 